import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=0b650c3b&scoped=true&"
import script from "./BaseAccordion.vue?vue&type=script&lang=ts&"
export * from "./BaseAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAccordion.vue?vue&type=style&index=0&id=0b650c3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b650c3b",
  null
  
)

export default component.exports